import React, { useEffect, useState } from 'react';
import _ from "../../../utils/firebase";
import '../../../public/stylesheets/style-confirm.css';
import { ModelCodeSecretFeature } from '../../classcomponent/modelCodeSecretFeature';

function DelCodeSecreFeature () {
    
    const delData = async () => {

        const id = ModelCodeSecretFeature.prototype.id;
        const query = document.querySelector(`[id=data${id}]`);
        query.remove();

        await _.secret_code.doc(id).delete();

        CloseFormDelData();

    }

    const CloseFormDelData = () => {

        var _form = document.getElementById('formDelDataSecreFeature');
        _form.style.top = '-100%';
        
    }

    return(

        <div className='formDelData' id='formDelDataSecreFeature'>
            <div className='box-data'>

                <div className='text-white'>
                    <h1 >ลบรหัสโค้ด ฟีเจอร์ลับ</h1>
                </div>
                <div className='form-input'>
                    <span>ผู้ใช้งาน</span>
                    <input className='form-control' id={'_delmember'} type='text' ></input>
                </div>
                <div className='form-input'>
                    <span>รหัสโค้ด</span>
                    <input className='form-control' id={'_delcode'} type='number' readOnly></input>
                </div>
                <div className='form-input'>
                    <span>เวลาหมดอายุ</span>
                    <input className='form-control' id={'_delexpire'} type='text'  readOnly></input>
                </div>
                <div className='form-input-btn'>
                    <div className='form-btn'>
                        <button className='btn btncreate' type='submit' onClick={delData}>ยืนยัน</button>
                        <button className='btn btncancel' onClick={CloseFormDelData}>ยกเลิก</button>
                    </div>                   
                </div> 

            </div>
        </div>
    )

}


export default DelCodeSecreFeature;